module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner01.jpg"),
      "url": "plist/list/122950"
    },
    on: {
      "click": function($event) {
        return _vm.toPlistPage($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner02.jpg"),
      "url": "plist/list/122774"
    },
    on: {
      "click": function($event) {
        return _vm.toPlistPage($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner03.jpg"),
      "url": "plist/list/122759"
    },
    on: {
      "click": function($event) {
        return _vm.toPlistPage($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78728a9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner2.vue
// module id = 104
// module chunks = 0